<div class="l-container  u-margin-top-xl">
  <div class="l-grid  l-grid--horizontal-center">
    <div class="l-grid__unit l-grid__unit--7of12@medium l-grid__unit--5of12@large">

      <div class="c-card">
        <div class="c-card__body">

          <div class="c-form">
            <h1 class="c-h1">{{ 'SEARCH_PAGE.searchMember' | translate}}</h1>
            <div class="c-form__element">
              <label class="c-form__label" for="inss">{{ 'SEARCH_PAGE.inss' | translate}}</label>
              <input class="c-form__input" type="text" name="inss" id="inss" (input)="setInss(memberInput.value)" (keyup.enter)="searchMemberWithEnterButton()" #memberInput>
            </div>
            @if (searchState$ | async; as searchState) {
              <myabvv-alert [condition]="searchState.error" [message]="errorMessage" [type]="errorStatus === 404  ? 'warning' : 'error'"></myabvv-alert>
              <myabvv-alert [condition]="(isOpenedInNewTab$ | async) && memberInput.value.length <= 0" [message]="'SEARCH_PAGE.search_member_first'" [type]="'warning'"></myabvv-alert>
              <p>
                <myabvv-search-button
                  [disabled]="searchState.loading || !isValidInss(memberInput.value)"
                  (searchClick)="searchMember(memberInput.value)">
                </myabvv-search-button>
                @if (searchState.loading) {
                  <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
                }
              </p>
            } @else {
              <myabvv-alert [condition]="(isOpenedInNewTab$ | async) && memberInput.value.length <= 0" [message]="'SEARCH_PAGE.search_member_first'" [type]="'warning'"></myabvv-alert>
              <p>
                <myabvv-search-button
                  [disabled]="!isValidInss(memberInput.value)"
                  (searchClick)="searchMember(memberInput.value)">
                </myabvv-search-button>
              </p>
            }
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
